import React from 'react';

const Arrow = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g fill={color}>
        <g>
          <g>
            <g>
              <path
                d="M6.016 19.3L16.348 8.996 16.348 16.948 17.86 16.948 17.86 6.336 7.22 6.336 7.22 7.876 15.256 7.848 4.924 18.18z"
                transform="translate(-327 -152) translate(24 64) translate(0 88) translate(303)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Arrow;
